import { configureStore } from '@reduxjs/toolkit';
import { createSelectorHook, useDispatch } from 'react-redux';
import rootReducer, { AppState, additionalMiddleware, history } from './reducers';
import { getSentryReduxEnhancer } from 'shared/utils/sentry';

const isDev = process.env.NODE_ENV === 'development';

export const setupStore = () =>
  configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: true,
        serializableCheck: true,
        immutableCheck: false, // Disabled for performance
      }).concat(additionalMiddleware),

    enhancers: [getSentryReduxEnhancer()],
  });

export const store = setupStore();
export type RootState = ReturnType<typeof store.getState>;
export type Store = typeof store;

if (isDev && module.hot) {
  module.hot.accept('./reducers', () =>
    store.replaceReducer(require('./reducers').default),
  );
}

export { history };
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = createSelectorHook<AppState>();
